// ./utils/petSitterUtils.ts

/**
 * Converts a PetSitterProfile to a DTO suitable for a user box component.
 * @param profile - A pet sitter profile object.
 * @returns A formatted object for display.
 */
export const petSitterProfileToUserBoxDTO = (profile: any) => {
  return {
    ...profile,
    id: profile.uuid,
    avatar: {
      imageThumbnailUrl: profile.picture?.thumbnailUrl,
    },
  }
}
